module.exports = __webpack_public_path__ + "uK9sO6mmf5L0OqWIh/rdc_pro_logo.svg";